import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchData } from "../../Components/common/utils";
const BlogPost = () => {
  const param = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/blog/detail/" + param.id;
      const result = await fetchData(url);
      if (result) {
        setData(result.data);
      }
      setLoading(false);
    };
    fetchApiData();
  }, []);

  return (
    <>
      <style>{` 
      .blog-main-img::before{
      background-image:url(${data?.media[0]?.original_url});
      }
      `}</style>
      <div>
        {loading ? (
          <>
            <div className="skeleton blog-main-img-skeleton"></div>
            <div className="container">
              <div className="skeleton skeleton-title"></div>
              {Array.from({ length: 10 }).map((_, i) => (
                <div key={i} className="skeleton skeleton-text"></div>
              ))}
            </div>
          </>
        ) : (
          <>
            <div className="blog-main-img d-flex align-items-center justify-content-center">
              <h2 className="text-center blog-post-title">{data?.title}</h2>
            </div>
            <div
              dangerouslySetInnerHTML={{ __html: data?.long_description }}
              className="container my-4"
            />
          </>
        )}
      </div>
    </>
  );
};

export default BlogPost;
